/**
 * @name: formatDate.js
 * @description: 日期格式化成指定样式
 * @author: 温永江
 * @create: 2020/07/22 14:28:01
 * @update: 2020/07/22 14:28:01
 */

export default (v) => {
  let value = v;
  if (typeof value === 'string') {
    [value] = value.split('.');
    value = (`${value}Z`)
      .replace(/\//g, '-')
      .replace(/[\u4E00-\u9FA5]/g, '')
      .replace(/-(\d+)-(\d+)/, (all, a, b) => {
        /^\d$/.test(a) && (a = `0${a}`);
        /^\d$/.test(b) && (b = `0${b}`);
        return `-${a}-${b}`;
      })
      .replace(/(\d+):(\d+):(\d+)/, (all, a, b, c) => {
        let arrTemp = [];
        /^\d$/.test(a) && (a = `0${a}`);
        /^\d$/.test(b) && (b = `0${b}`);
        /^\d$/.test(c) && (c = `0${c}`);
        arrTemp.push(a, b, c);
        return arrTemp.join(':');
      })
      .replace(/\d(\s+)\d/, (all, a) => {
        if (/^\s+$/.test(a)) {
          return all.replace(a, 'T');
        }
      }); // 强制把时间格式加T
  }
  let dt = value;
  if (Object.prototype.toString.call(dt) !== '[object Date]') {
    dt = new Date(new Date(value).toUTCString().replace('GMT', ''));
  }
  if (dt == 'Invalid Date') {
    // 后台有时候是mm-dd-yyy  经过前面一系列变化，在加上t，就成了无效的日期，加t 只能是yyyy-mm-dd
    if (value) {
      dt = new Date(
        new Date(value.replace(/t/i, ' ')).toUTCString().replace('GMT', '')
      );
    }
  }

  let year = dt.getFullYear();
  let month = parseInt(dt.getMonth()) + 1;
  let day = parseInt(dt.getDate());
  let hours = parseInt(dt.getHours());
  let minutes = parseInt(dt.getMinutes());
  let seconds = parseInt(dt.getSeconds());

  month = month < 10 ? `0${month}` : month;
  day = day < 10 ? `0${day}` : day;
  hours = hours < 10 ? `0${hours}` : hours;
  minutes = minutes < 10 ? `0${minutes}` : minutes;
  seconds = seconds < 10 ? `0${seconds}` : seconds;
  return {
    year: year,
    month: month,
    day: day,
    hours: hours,
    minutes: minutes,
    seconds: seconds
  };
};
